<template>
  <page-layout title="订单详情" class="p-PurchaseOrderList">
    <znl-button
      type="text"
      slot="title"
      @click="store.commit('setRoute', { name: 'PurchaseOrderList' })"
      >返回</znl-button
    >

    <div class="p-PurchaseOrderList-header">
      <div class="infoitem">
        <label>当前状态：</label>
        <span class="status-text">{{ OrderStatus }}</span>
      </div>
      <div class="infoitem">
        <p class="value">{{ OrderInfo.OrderNo }}</p>
        <p class="label">订单编号</p>
      </div>
      <div class="infoitem">
        <p class="value">{{ OrderInfo.CreateTime }}</p>
        <p class="label">创建时间</p>
      </div>
      <div class="infoitem" v-if="OrderInfo.PayTime">
        <p class="value">{{ OrderInfo.PayTime }}</p>
        <p class="label">付款时间</p>
      </div>
      <div class="infoitem" v-if="OrderInfo.SendTime">
        <p class="value">{{ OrderInfo.SendTime }}</p>
        <p class="label">发货时间</p>
      </div>
      <div class="infoitem" v-if="OrderInfo.SuccessTime">
        <p class="value">{{ OrderInfo.SuccessTime }}</p>
        <p class="label">成交时间</p>
      </div>
    </div>

    <div class="p-PurchaseOrderList-order-info clearfix">
      <div class="info-item address-info pull-left">
        <h4>
          <div>收件信息</div>
        </h4>
        <el-row>
          <label>运输方式：</label>
          <span>{{ OrderInfo.IsByOneself ? '自提' : '快递(到付)' }}</span>
        </el-row>
        <el-row>
          <label>收件人：</label>
          <span>{{
            OrderInfo.IsByOneself ? '袁小姐' : OrderInfo.Contact
          }}</span>
        </el-row>
        <el-row>
          <label>联系电话：</label>
          <span>{{
            OrderInfo.IsByOneself ? '0755-82798001' : OrderInfo.Phone
          }}</span>
        </el-row>
        <el-row class="clearfix">
          <label class="pull-left">收件地址：</label>
          <span class="pull-left value">{{
            OrderInfo.IsByOneself
              ? '华强北街道荔村社区华强北路2006号桑达418栋4层（曼哈双创中心）A39室'
              : OrderInfo.Address
          }}</span>
        </el-row>
      </div>
      <div class="info-item invoice-info pull-left">
        <h4>
          <div>发票信息</div>
        </h4>
        <el-row>
          <label>发票类型：</label>
          <span>{{
            OrderInfo.IsInvoice ? '增值税专用发票' : '不需要发票'
          }}</span>
        </el-row>
        <el-row>
          <label>发票抬头：</label>
          <span>{{
            OrderInfo.InvoiceResult
              ? OrderInfo.InvoiceResult.InvoiceCompanyName
              : ''
          }}</span>
        </el-row>
        <el-row>
          <label>发票内容：</label>
          <span>商品明细</span>
        </el-row>
        <el-row>
          <label>收票地址：</label>
          <span>{{
            OrderInfo.InvoiceResult
              ? OrderInfo.InvoiceResult.CollectorAddress
              : ''
          }}</span>
        </el-row>
      </div>
    </div>

    <div class="p-PurchaseOrderList-order-list">
      <h4>
        <div>物料清单</div>
      </h4>
      <!-- <div class="SupplierName">
        <span @click="showQQ">
          <i class="qqback"></i>
          在线客服
        </span>
      </div> -->
      <div class="OrderInfoGrid">
        <div class="order-grid-container">
					<table>
              <th>
                <td v-for="(col, k) in columns" :key="k" :style="{textAlign: col.textAlign || 'left'}">
                  {{ col.header }}
                </td>
              </th>
            </table>
          <div
            class="sourceType"
            :class="[`sourceType${index}`]"
            v-for="(item, index) in gridDatas"
            :key="index"
          >
            <div class="title">
              {{
                item.type === 1
                  ? '电商直供'
                  : item.type === 2
                  ? '现货直供'
                  : item.type === 3
                  ? 'BOM秒配'
                  : item.type === 4
                  ? 'VIP配单'
                  : ''
              }}
            </div>
            <table class="data-table">
              <tr v-for="(data, j) in item.data" :key="j">
                <td 
									v-for="(col, k) in columns" 
									:key="k" 
									:class="[`cell-${col.binding}`]"
									:style="{textAlign: col.textAlign || 'left'}">
									<span v-if="col.binding === 'Amount'">
                  	￥{{ data[col.binding] }}
									</span>
									<span v-else>
                  	{{ data[col.binding] }}
									</span>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="OrderInfoAmount clearfix">
					<div class="pull-left statement">
						<p>协议声明:</p>
						<p>
							正能量承诺所有货源均为正品现货，假一赔三。由于电商直供库存数据为实时数据，大部分商品由BomAI供应商提供(若有疑问您可<span class="button"><a :href="`mailto:taqiu@mail.bom.ai?subject=申请查看供应商&body=请填写订单号及申请型号`">点此申请</a></span>查看供应商)，实际下单采购时货源可能会发生变化，若发生交期延误、供应商涨价、数量补发甚至供应商撤单等异常状况，正能量将尽最大努力协商解决，但不承担由此而导致的任何直接和间接经济损失。
						</p>
						
					</div>
          <div class="pull-right">
            <div class="bgAmount">
              <div>
                <label>货物总额：</label
                ><span class="colormain">¥{{ OrderInfo.CostAmount }}</span>
              </div>
              <div>
                <!-- <label>运费：</label> -->
                <label>服务费：</label>
                <span class="colormain">¥{{ OrderInfo.OrderCost }}</span>
              </div>
							<div> 
								<label>运费：</label>
								<span class="colormain">到付</span>
							</div>
            </div>
            <div class="Amount">
              订单金额：<span class="colormain Amounttext"
                >¥{{ Math.round(OrderInfo.Amount * 100) / 100 }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </page-layout>
</template>
<script>
import TradingStore from '../../store';
import PageLayout from '../PageLayout';
import { httpGet } from '../../assets/scripts/http';

export default {
  name: 'PurchaseOrderListDetails',
  components: {
    PageLayout
  },
  props: {
    companyClickHandler: Function
  },
  data() {
    return {
      store: TradingStore,
      columns: [
        // {
        //   binding: 'TrackCode',
        //   header: '跟踪码'
        // },
        {
          binding: 'PartNo',
          name: 'PartNo',
          header: '型号'
        },
        {
          binding: 'Brand',
          name: 'Brand',
          header: '品牌'
        },
        {
          binding: 'Package',
          name: 'Package',
          header: '封装'
        },
        {
          binding: 'MakeYear',
          name: 'MakeYear',
          header: '年份'
        },
        {
          binding: 'Qty',
          name: 'Qty',
					header: '数量',
					textAlign: 'center'
        },
        {
          binding: 'Price',
          name: 'Price',
					header: '单价',
					textAlign: 'center'
        },
        {
          binding: 'Amount',
          name: 'Amount',
					header: '金额',
					textAlign: 'center'
        }
      ],
      OrderInfo: { InvoiceResult: {}, Lines: [] }
    };
  },
  computed: {
    OrderStatus() {
      let Str = '';
      switch (this.OrderInfo.Status) {
        case 0:
          Str = '待确认';
          break;
        case 1:
          Str = '待支付';
          break;
        case 2:
          Str = '审核中';
          break;
        case 3:
          Str = '待发货';
          break;
        case 4:
          Str = '已发货';
          break;
        case 5:
          Str = '已取消';
          break;
        case 6:
          Str = '已完成';
          break;
        default:
          break;
      }
      return Str;
    },
    gridDatas() {
      const lines = this.OrderInfo.Lines;
      const Datas = [];
      const d1 = lines.filter(d => d.SourceType === 1);
      const d2 = lines.filter(d => d.SourceType === 2);
      const d3 = lines.filter(d => d.SourceType === 3);
      const d4 = lines.filter(d => d.SourceType === 4);
      if (d1.length > 0) {
        Datas.push({
          type: 1,
          data: d1
        });
      }
      if (d2.length > 0) {
        Datas.push({
          type: 2,
          data: d2
        });
      }
      if (d3.length > 0) {
        Datas.push({
          type: 3,
          data: d3
        });
      }
      if (d4.length > 0) {
        Datas.push({
          type: 4,
          data: d4
        });
			}
			
			if (Datas.length === 0) {
				Datas.push({
					type: '',
					data: lines
				})
			}
      return Datas;
    }
  },
  created() {
    const id = this.store.state.route.params.id;
    this.getOrderAndDetail(id);
  },
  methods: {
    getOrderAndDetail(id) {
      httpGet(`bomorder/getOrderAndDetail?id=${id}`).then(res => {
        if (res.Code === 0) {
          this.OrderInfo = res.Data || { InvoiceResult: {} };
        }
      });
    },
    showQQ() {
      window.open(
        'http://wpa.qq.com/msgrd?v=3&uin=2243731620&site=qq&menu=yes',
        '_brank'
      );
		}
  }
};
</script>
<style lang="scss">
.p-PurchaseOrderList {
  font-size: 12px;
  .colormain {
    font-weight: bold;
    color: #ee7700;
  }
  h4 {
    color: $--fontcolor-dark-3;
    font-size: 16px;
    line-height: 40px;
    font-weight: bold;
    padding-right: 20px;
    div {
      border-bottom: 1px solid #d8dde8;
    }
  }
  .qqback {
    display: inline-block;
    width: 19px;
    height: 18px;
    background-repeat: no-repeat;
    background: url(../../assets/imgs/bomIcon.png);
    background-position: -447px -28px;
    position: relative;
    top: 4px;
  }
  .p-PurchaseOrderList-header {
    height: 70px;
    border: 1px solid #e6e6e6;
    background-color: #fff;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    padding: 0 20px;
    .infoitem {
      margin-right: 50px;
      .status-text {
        font-size: 24px;
        color: #139c25;
        font-weight: bold;
      }
      label,
      .label {
        font-size: 12px;
        color: $--fontcolor-dark-2;
      }
      .value {
        font-size: 14px;
        height: 16px;
        line-height: 16px;
      }
    }
  }
  .p-PurchaseOrderList-order-info {
    background-color: #fff;
    border: 1px solid #e6e6e6;
    margin-top: 10px;
    padding: 0 20px;
    .info-item {
      width: 50%;
      box-sizing: border-box;

      .el-row {
        line-height: 40px;
        padding-left: 10px;
      }
      label {
        display: inline-block;
        width: 100px;
        color: $--fontcolor-dark-3;
      }
    }
  }
  .p-PurchaseOrderList-order-list {
    background-color: #fff;
    margin-top: 10px;
    padding: 0 20px;
    .SupplierName {
      line-height: 40px;
      color: #333333;
      font-size: 14px;
      font-weight: bold;
      span {
        cursor: pointer;
      }
    }
    .OrderInfoGrid {
      background-color: #fff;
    }
    .order-grid-container {
      padding-bottom: 30px;
			padding-top: 10px;
      border-bottom: 2px solid #cccccc;
      table {
        width: 100%;
      }
      tr, th {
        display: flex;
        td {
          flex: 1;
					height: 30px;
					line-height: 30px;
					padding: 0 5px;
					box-sizing: border-box;
        }
      }
			th{
				background-color: #E6F0FA;
				text-align: left;
				color: $--fontcolor-dark-3;
				font-weight: bold;
			}
			.title{
				line-height: 30px;
				padding-top: 5px;
				color: #333333;
				font-size: 14px;
				font-weight: bold;
				padding-left: 2px;
			}
			.data-table{
				border-top:  1px solid #D8D8D8;
				border-left:  1px solid #D8D8D8;
				td{
					border-right: 1px solid #D8D8D8;
					border-bottom: 1px solid #D8D8D8;
				}
			}
			.cell-Amount{
				color: #ee7700;
				font-weight: bold;
			}
    }
    .OrderInfoAmount {
      padding: 20px 0;
      font-size: 12px;
			.statement,
			.statement a{
				color: #CCC;
				width: 500px;
				.button{
					cursor: pointer;
				}
				p{
					line-height: 20px;
					&:first-child{
						color: #999;
						font-weight: bold;
						// padding: 5px 0;
					}
				}
			}
      .bgAmount {
        background-color: #f7f7f7;
        padding: 10px 20px;
        line-height: 26px;
        label {
          display: inline-block;
          width: 60px;
          text-align: right;
        }
        span {
          display: inline-block;
          min-width: 50px;
          text-align: right;
        }
      }
      .Amount {
        color: $--fontcolor-dark-4;
        font-size: 14px;
        font-weight: bold;
        text-align: right;
        line-height: 50px;
        .Amounttext {
          font-size: 20px;
        }
      }
    }
  }
}
</style>
